// extracted by mini-css-extract-plugin
module.exports = {"shareBackground":"ShareDownloadHelper_shareBackground__Vcc9t","lionDsc":"ShareDownloadHelper_lionDsc__keyqa","lionImage":"ShareDownloadHelper_lionImage__HawWZ"};